import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import {
  LOCK_BANNER_GRADIENT_END,
  LOCK_BANNER_GRADIENT_START,
} from "@src/appV2/lib/Theme/constants";
import { generatePath, useHistory } from "react-router-dom";

import { Button } from "../../components/Button";

interface InHomeLockBannerProps {
  lockedByWorkplaceId: string;
}

export function InHomeLockBanner(props: InHomeLockBannerProps) {
  const { lockedByWorkplaceId } = props;
  const history = useHistory();

  return (
    <Box
      sx={(theme) => ({
        borderRadius: theme.shape.borderRadius * 2,
        padding: 5,
        background: `linear-gradient(135deg, ${LOCK_BANNER_GRADIENT_START} 0%, ${LOCK_BANNER_GRADIENT_END} 100%)`,
      })}
    >
      <Stack direction="row" spacing={3} alignItems="center">
        <Box
          sx={(theme) => ({
            backgroundColor: theme.palette.background.tertiary,
            borderRadius: "50%",
            padding: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          })}
        >
          <CbhIcon type="locked-filled" size="large" />
        </Box>
        <Text semibold variant="body1">
          Your Home Health Access Is Locked
        </Text>
      </Stack>
      <Button
        fullWidth
        variant="outlined"
        sx={(theme) => ({
          marginTop: 4,
          borderColor: theme.palette.border?.primary,
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.background.primary,
        })}
        onClick={() => {
          logEvent(APP_V2_USER_EVENTS.VISIT_LOCK_BANNER_FIND_OUT_WHY_TAPPED, {
            lockedByWorkplaceId,
          });
          history.push(
            generatePath(DeprecatedGlobalAppV1Paths.CHAT, {
              facilityId: lockedByWorkplaceId,
            })
          );
        }}
      >
        Find Out Why
      </Button>
    </Box>
  );
}
